import { useState, useEffect } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { toast } from "react-toastify";
import config from "../../../../../../config";
import { useDispatch } from "react-redux";
import { PRESUPUESTOS_API } from "../../../shared/services/presupuestos";
import ConfirmModal from "../../../shared/components/ConfirmModal";

// id del transportista "Reparto Propio" (Recomotor) — ver EnvioSearcher
const RECOMOTOR_CARRIER_ID = 40;

// Solo el transporte de las piezas en reparto propio se oculta y se suma al precio
// de pieza mostrado al cliente. El resto de transportistas (DHL, etc.) no se tocan.
const getTransportePropio = (presupuesto) =>
  (presupuesto?.piezas ?? []).reduce((acc, pieza) => {
    const servicioEnvio = pieza?.servicio_envio;
    const transportistaId = servicioEnvio?.transportista_id ?? servicioEnvio?.transportista?.id;
    if (Number(transportistaId) === RECOMOTOR_CARRIER_ID) {
      return acc + (parseFloat(servicioEnvio?.precio_transporte) || 0);
    }
    return acc;
  }, 0);

export default function PlantillaEmailModal({ plantillas, presupuesto }) {
  /** Redux **/
  const dispatch = useDispatch();

  /** States **/
  const [currentPlantilla, setCurrentPlantilla] = useState(null);
  const [updatedPlantillas, setUpdatedPlantillas] = useState([]);
  const [confirmModalOpened, setConfirmModalOpened] = useState(false);

  /** Effects **/
  useEffect(() => {
    const transportePropio = getTransportePropio(presupuesto);

    setUpdatedPlantillas(
      plantillas.map((plantilla) => {
        return {
          ...plantilla,
          contenido: plantilla?.contenido
            ?.replace("$TOTAL_SIN_IVA", ((parseFloat(presupuesto.total) || 0) + transportePropio).toFixed(2))
            .replace("$ENVIO", ((parseFloat(presupuesto.total_envio) || 0) - transportePropio).toFixed(2))
            .replace("$TOTAL_CON_IVA", presupuesto.total_iva || "0")
            .replace(
              "$LINK_CHECKOUT",
              config.recomotor.clientsUrl +
                "checkout/" +
                presupuesto.checkout_id || "[$LINK_CHECKOUT]"
            )
            .replace(
              "$CREATOR_NAME",
              presupuesto.created_by?.username
                ? presupuesto.created_by.username
                    .split("_")
                    .map((part) => part[0].toUpperCase() + part.slice(1))
                    .join(" ")
                : "[$USER_NAME]"
            )
            .replace("$CASCO", presupuesto.total_casco || "0"),
        };
      })
    );
  }, []);

  /** Methods **/
  const copyTemplateToClipboard = () => {
    navigator.clipboard.writeText(currentPlantilla);
    toast.success("Plantilla copiada!");
  };

  const handleConfirmAbrirImagenes = (confirmed) => {
    setConfirmModalOpened(false);
    if (!confirmed) {
      return;
    }
    abrirImagenes(presupuesto);
  };

  const abrirImagenes = async (presupuesto) => {
    presupuesto.piezas?.forEach(async (pieza) => {
      const images = pieza.integracion_imgs;
      if (images?.length > 1) {
        images?.forEach(async (image) => {
          window.open(image, "_blank");
        });
      } else {
        window.open(pieza.url, '_blank', 'noopener,noreferrer');
      }
    });
  };

  const generarPDF = async (presupuesto) => {
    dispatch({ type: "loading/set", payload: true });
    const pdfResult = await PRESUPUESTOS_API.getPDF(presupuesto.id).finally(() =>
      dispatch({ type: "loading/set", payload: false })
    );

    if (pdfResult) {
      toast.success("PDF generado correctamente!");
      const url = window.URL.createObjectURL(new Blob([pdfResult]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", presupuesto.numero + ".pdf"); //or any other extension
      document.body.appendChild(link);
      link.click();
    } else {
      toast.error("Ups! Algo ha ido mal...");
    }
  };

  /** Render **/
  return (
    <div>
      {updatedPlantillas?.map((plantilla) => (
        <Accordion
          onChange={() => setCurrentPlantilla(plantilla.contenido)}
          key={plantilla.id}
        >
          <AccordionSummary
            aria-controls="panel1-content"
            id="mejoras-metricas"
          >
            <strong
              style={{
                color: "#215731",
                position: "absolute",
                display: "block",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                maxWidth: "90%",
                top: "1rem",
              }}
            >
              {plantilla.nombre}
            </strong>
          </AccordionSummary>
          <AccordionDetails>
            <div className="d-flex flex-column">
              <textarea
                rows={15}
                defaultValue={plantilla.contenido}
                onChange={(e) => setCurrentPlantilla(e.target.value)}
              />
              <div className="d-flex mt-3">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => generarPDF(presupuesto)}
                >
                  PDF
                </button>
                <button
                  type="button"
                  className="btn btn-primary ms-3"
                  onClick={() => setConfirmModalOpened(true)}
                >
                  Imagenes
                </button>
                <button
                  type="button"
                  className="btn btn-primary ms-auto"
                  onClick={copyTemplateToClipboard}
                >
                  Copiar
                </button>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
      ))}
      {confirmModalOpened && (
        <ConfirmModal
          onConfirmAction={handleConfirmAbrirImagenes}
          onCancelAction={() => setConfirmModalOpened(false)}
          onClose={() => setConfirmModalOpened(false)}
          title={"Imagenes"}
          description={ "Los datos solicitados se abrirán en ventana nueva. ¿Desea continuar?" }
          state={confirmModalOpened}
        ></ConfirmModal>
      )}
    </div>
  );
}
